import React from 'react'

import ReviewParameter from './ReviewParameter'

import {
  IProjectVersionSettingsReviewParameterOption,
} from '@SiteModules/ProjectVersionSettings/types'

export const ENHANCE_CLEAN_ORIGINAL_AUDIO = 'enhance_clean_original_audio'

const CLEAN_ORIGINAL_AUDIO_LABEL = 'Clean original audio'

interface EnhanceAudioParameterProps {
  readonly enhanceAudioOptions: string[]
  setEnhanceAudioOptions(newOptions: string[]): void
}

const EnhanceAudioParameter: React.FC<EnhanceAudioParameterProps> = props => {
  const {
    enhanceAudioOptions,
    setEnhanceAudioOptions,
  } = props

  const availableOptions: IProjectVersionSettingsReviewParameterOption[] = [{
    name: ENHANCE_CLEAN_ORIGINAL_AUDIO,
    nameToShowInDropdown: CLEAN_ORIGINAL_AUDIO_LABEL,
    description: 'Removes background noise and clarifies speech from your source audio before transcription and downstream processing.',
  }]

  const hasClean = enhanceAudioOptions.includes(ENHANCE_CLEAN_ORIGINAL_AUDIO)

  const buttonText = hasClean ? CLEAN_ORIGINAL_AUDIO_LABEL : 'Audio enhancement: off'

  return (
    <ReviewParameter
      reviewModeOptions={enhanceAudioOptions}
      availableOptions={availableOptions}
      setReviewModeOptions={setEnhanceAudioOptions}
      buttonText={buttonText}
      dropdownDirection="up"
      optionInputIdPrefix="enhance-audio"
      buttonAdvancedInactive={enhanceAudioOptions.length === 0}
    />
  )
}

export default EnhanceAudioParameter
